import React from 'react';
import TableHeader from './TableHeader';
import TableContent from './TableContent';
import TableFooter from './TableFooter';

const NoMatchTable = ({
  tableId,
  zones,
  key1,
  val1,
  doc2Visibility,
  toggleDoc2Visibility,
  handleStayCheckedMatched,
  returnDoc2Zones,
  noMatchTableStyle,
  theadStyle,
  tbodyStyle,
  trStyle,
  thStyle,
  tdValueStyle,
  verticalLabel,
  containsPropVal,
  tdPropStyle,
  findDocNumber,
  data,
  comparisonID,
  setDoc1Name,
  setDoc2Name,
  renderProperNote,
  renderAddNote,
  handleCheckedMatched,
  handleCheckboxChange,
  lastRow,
  markForExport,
  doc1Name,
  doc2Name
}) => {
  return (
    <table 
      key={tableId} 
      id={tableId} 
      style={noMatchTableStyle}
    >
      <TableHeader 
        key1={key1}
        zones={zones}
        doc2Visibility={doc2Visibility}
        toggleDoc2Visibility={toggleDoc2Visibility}
        handleStayCheckedMatched={handleStayCheckedMatched}
        returnDoc2Zones={returnDoc2Zones}
        theadStyle={theadStyle}
      />
      
      <TableContent 
        key1={key1}
        val1={val1}
        doc2Visibility={doc2Visibility}
        tbodyStyle={tbodyStyle}
        trStyle={trStyle}
        thStyle={thStyle}
        tdValueStyle={tdValueStyle}
        verticalLabel={verticalLabel}
        containsPropVal={containsPropVal}
        tdPropStyle={tdPropStyle}
        findDocNumber={findDocNumber}
        data={data}
        comparisonID={comparisonID}
        setDoc1Name={setDoc1Name}
        setDoc2Name={setDoc2Name}
        doc1Name={doc1Name}
        doc2Name={doc2Name}
      />
      
      <tbody>
        {renderProperNote(tableId)}
      </tbody>
      
      <TableFooter 
        tableId={tableId}
        tbodyStyle={tbodyStyle}
        lastRow={lastRow}
        renderAddNote={renderAddNote}
        handleCheckedMatched={handleCheckedMatched}
        handleStayCheckedMatched={handleStayCheckedMatched}
        handleCheckboxChange={handleCheckboxChange}
        markForExport={markForExport}
      />
    </table>
  );
};

export default NoMatchTable;
